module.exports = __webpack_public_path__ + "img/13.46a9321c.jpg";